import generateAdjustedEventTraits from 'src/js/modules/element-settings/helpers/generate-adjusted-event-traits';
import appearanceAttributes from '../constants/appearance-attributes';

const getTraitName = (attribute) => {
  switch (attribute) {
    case appearanceAttributes.BORDER: {
      return 'Border';
    }

    case appearanceAttributes.SHADOW: {
      return 'Shadow';
    }

    case appearanceAttributes.BORDER_TOP_LEFT_RADIUS:
    case appearanceAttributes.BORDER_TOP_RIGHT_RADIUS:
    case appearanceAttributes.BORDER_BOTTOM_LEFT_RADIUS:
    case appearanceAttributes.BORDER_BOTTOM_RIGHT_RADIUS: {
      return 'Corners';
    }

    default: {
      return attribute;
    }
  }
};

const getMediaAppearanceAdjustedTraits = ({ prefix, modifiedAttributes }) => {
  const adjustedTraits = modifiedAttributes.reduce((accTraits, attribute) => {
    const currentTraitName = getTraitName(attribute);
    const currentTraits = generateAdjustedEventTraits(prefix, currentTraitName, true);

    return {
      ...accTraits,
      ...currentTraits,
    };
  }, {});

  return adjustedTraits;
};

export default getMediaAppearanceAdjustedTraits;
